// extracted by css-extract-rspack-plugin
export default {"starredIcon":"StarButton-module__starredIcon__BIYQ5"};